import { useSearchParams } from 'react-router-dom'

/* TEMPORARY route stubs — each is replaced by its milestone:
 *   /history      -> M10 (static mock in the original)
 *   /directions   -> M10 (static mock)
 *   /test         -> M10 (untouched FlutterFlow scaffold)
 *   /trackingCopy -> M10 (dead fork, behind ENABLE_TRACKING_COPY)
 * Marked with data-page for router verification. */

function Stub({ page, note }: { page: string; note: string }) {
  return (
    <div data-page={page} style={{ padding: 24 }}>
      <p style={{ fontFamily: 'var(--font-poppins-regular)', fontSize: 20 }}>
        {page}
      </p>
      <p style={{ fontFamily: 'var(--font-inter)', fontSize: 14, color: 'var(--secondary-text)' }}>
        {note}
      </p>
    </div>
  )
}

export function HistoryStub() {
  return <Stub page="history" note="статичний мок — M10" />
}

export function DirectionsStub() {
  return <Stub page="directions" note="статичний мок — M10" />
}

export function TestStub() {
  return <Stub page="test" note="скаффолд FlutterFlow — M10" />
}

export function TrackingCopyStub() {
  const [params] = useSearchParams()
  return (
    <Stub
      page="trackingCopy"
      note={`userId: ${params.get('userId') ?? '(немає)'} — мертвий форк, M10`}
    />
  )
}
